import { Path, Rect } from "react-native-svg";

import { type IconProps, LineIcon } from "./LineIcon";

export function LockIcon(props: IconProps) {
  return (
    <LineIcon {...props}>
      <Rect x="5" y="10.5" width="14" height="10" rx="2" />
      <Path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" />
      <Path d="M12 14.5v2.5" />
    </LineIcon>
  );
}
